export const GAME_IDS = {
  FAVORITE_DANCES: "favorite_dances",
  /** @deprecated legacy id */
  MOST_FUN_DANCER: "most_fun_dancer",
};

export const GAME_STATES = {
  UPCOMING: "upcoming",
  LIVE: "live",
  COMPLETED: "completed",
};

export const GAME_CLOSE_REASONS = {
  WINDOW_ELAPSED: "window_elapsed",
  ALL_VOTED: "all_voted",
  ALL_CHECKED_OUT: "all_checked_out",
};

export function gameStatusLabel({ state, closeReason }) {
  if (state !== GAME_STATES.COMPLETED) return state === GAME_STATES.LIVE ? "Live" : "Upcoming";
  if (closeReason === GAME_CLOSE_REASONS.ALL_VOTED) return "Results in";
  if (closeReason === GAME_CLOSE_REASONS.ALL_CHECKED_OUT) return "Results in";
  return "Completed";
}

export function gameCountdownLabel({ state, closeReason, countdown }) {
  if (state !== GAME_STATES.COMPLETED) return countdown;
  if (closeReason === GAME_CLOSE_REASONS.ALL_VOTED) return "Everyone voted";
  if (closeReason === GAME_CLOSE_REASONS.ALL_CHECKED_OUT) return "Floor cleared";
  return "Closed";
}
